<template>
  <div>
    <v-row no-gutters align="center">
      <span
        class="black--text font-weight-bold text-right mr-2"
        v-text="quantity"
      />
      <v-btn icon :disabled="decrementDisabled" @click="decrement()">
        <v-icon v-text="icons.minusCircle" />
      </v-btn>
      <v-btn icon @click="increment()">
        <v-icon v-text="icons.plusCircle" />
      </v-btn>
    </v-row>
  </div>
</template>

<script>
  import Lockable from '@/Mixins/Lockable'
  import UsesIcons from '@/Mixins/UsesIcons'

  export default {
    mixins: [
      Lockable,
      UsesIcons,
    ],

    computed: {
      menu () {
        return this.$store.state.orders.menu
      },
      quantity () {
        return this.menu.quantity
      },
      minQuantity () {
        return this.menu.item.minQuantity
      },
      decrementDisabled () {
        if (this.quantity <= 1) {
          return true
        }
        if (! this.minQuantity) {
          return false
        }
        return (this.quantity - 1) < this.minQuantity
      },
    },

    methods: {
      set (v) {
        if (this.locked) {
          return
        }
        this.lock()
        this.$store.commit('orders/menu/quantity', v)
        this.$store.dispatch('orders/menu/validate')
        this.$emit('change')
      },
      increment () {
        this.set(this.quantity + 1)
      },
      decrement () {
        this.set(this.quantity - 1)
      },
    },
  }
</script>
